import { ClubRegisterData, actionTypes, Director } from 'store/clubs/types/types';

export const setClubDetails = (clubDetails: ClubRegisterData) => ({
  type: [actionTypes.SET_CLUB_DETAILS],
  payload: clubDetails,
});

export const setDirectors = (directors: Director[]) => ({
  type: [actionTypes.SET_DIRECTORS],
  payload: directors,
});

export const clearClubsData = (directors: Director[]) => ({
  type: [actionTypes.CLEAR_DATA],
});
